import { type JSX } from 'react';

import SearchOutlined from '@mui/icons-material/SearchOutlined';
import { type AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

import { TextField } from '@craft/ui/components/input';

/**
 * A render function for the 'renderInput' prop of the Autocomplete-based SearchBar, not a
 * component.  It is typed as a plain function (rather than 'FC') because the React 19 'FC'
 * return type includes Promise<ReactNode>, which MUI's synchronous 'renderInput' render prop
 * does not accept.
 */
export const SearchBarInput = (params: AutocompleteRenderInputParams): JSX.Element => (
  <TextField
    {...params}
    InputProps={{
      ...params.InputProps,
      startAdornment: <SearchOutlined />,
      type: 'search',
    }}
    placeholder='Search activity title or description'
  />
);
